import http from "@/apps/shared/baseService/config";

const base = {
  rota: "contatos-empresa",
  nome: "Contatos da Empresa"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  visualizar: data => http.post(`/admin/${base.rota}/view`, data),
  opcoes: data => http.post(`/admin/${base.rota}/options`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data)
};

const module = {
  actions: {
    listar_contatos_empresa: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar(getters.get_contatos_empresa_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("contatos_empresa", JSON.stringify(res.data));
          commit("set_contatos_empresa", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    },
    listar_opcoes_contatos_empresa: ({ commit, dispatch }) => {
      service
        .opcoes({})
        .then(res => {
          commit("set_contatos_empresa_opcoes", res.data || { users: [], unities: [] });
        })
        .catch(e => {
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    },
    criar_contato_empresa: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar(getters.get_contato_empresa)
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("contatos_empresa");
          commit("set_contato_empresa", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Contato cadastrado!",
            timeout: 6000
          });
          dispatch("listar_contatos_empresa");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    },
    atualizar_contato_empresa: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar(getters.get_contato_empresa)
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("contatos_empresa");
          commit("set_contato_empresa", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Contato atualizado!",
            timeout: 6000
          });
          dispatch("listar_contatos_empresa");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    },
    excluir_contato_empresa: ({ dispatch, commit }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          localStorage.removeItem("contatos_empresa");
          commit("set_contato_empresa", {});
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Contato removido!",
            timeout: 6000
          });
          dispatch("listar_contatos_empresa");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    }
  },
  state: {
    contato_empresa: {},
    contatos_empresa: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    contatos_empresa_opcoes: {
      users: [],
      unities: []
    },
    contatos_empresa_filtros: {
      limitPerPage: 2000,
      page: 1
    }
  },
  mutations: {
    set_contato_empresa: (state, payload) => (state.contato_empresa = payload),
    set_contatos_empresa: (state, payload) => (state.contatos_empresa = payload),
    set_contatos_empresa_opcoes: (state, payload) => (state.contatos_empresa_opcoes = payload),
    set_contatos_empresa_filtros: (state, payload) => (state.contatos_empresa_filtros = payload)
  },
  getters: {
    get_contato_empresa: state => state.contato_empresa,
    get_contatos_empresa: state => state.contatos_empresa,
    get_contatos_empresa_opcoes: state => state.contatos_empresa_opcoes,
    get_contatos_empresa_filtros: state => state.contatos_empresa_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
